import { useState, useEffect } from 'react';

import { useBsTrapsColumns } from './useBsTrapsColumns';
import BsTrapExpandable from './BsTrapExpandable';

import FilterDataTable from 'components/FilterDataTable/FilterDataTable';
import useGetBsTraps from 'hooks/Traps/BsTraps/useGetBsTraps';
import useScreenSize from 'hooks/Screen/useScreenSize';
import { BsTrapData } from 'api/traps/BsTraps/types';

interface TableProps {
  slug: string;
}

const BsTrapsTable: React.FC<TableProps> = ({ slug }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { data, refetch, isLoading } = useGetBsTraps(slug || '', page, search, ordering);
  const columns = useBsTrapsColumns(slug);
  const { isNotLargeDesktop } = useScreenSize();

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  return (
    <div className="bg-white ">
      <FilterDataTable<BsTrapData>
        columns={columns}
        data={data?.results || []}
        onChangePage={setPage}
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        isLoading={isLoading}
        expandableRows={isNotLargeDesktop}
        expandableRowsComponent={row => <BsTrapExpandable data={row.data} slug={slug} />}
      />
    </div>
  );
};

export default BsTrapsTable;
